// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style the quote details container */
.quoteDetails-container {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 1rem;
}

.noQuoteMessage {
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  margin-top: 1rem;
  padding: 8px;
  color: #247a97;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Style the quote details heading */
.quoteDetailsHeading {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 20px;
}

/* Style the quote details form */
.quoteDetailsCard {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Style the quote details card body */
.quoteDetailsCardBody {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 2rem;
}

/* Style the quote details card input fields */
.quoteDetailsCardBody label {
  display: block;
  margin-top: 1rem;
  margin-bottom: 5px;
  font-size: 2rem;
}

/* Style the quote details card input and textarea */
.quoteDetailsCardBody input,
.quoteDetailsCardBody textarea,
.quoteDetailsCardBody select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 2rem;
}

/* Style the quote details actions */
.quoteDetailsActions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* Style the quote details buttons */
.quoteDetailsActions button {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  font-size: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/QuoteDetails.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oDAAoD;AACpD;;;EAGE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Style the quote details container */\n.quoteDetails-container {\n  width: 80%;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-top: 1rem;\n}\n\n.noQuoteMessage {\n  font-size: 3rem;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 1rem;\n  padding: 8px;\n  color: #247a97;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Style the quote details heading */\n.quoteDetailsHeading {\n  font-size: 2.5rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n/* Style the quote details form */\n.quoteDetailsCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Style the quote details card body */\n.quoteDetailsCardBody {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-size: 2rem;\n}\n\n/* Style the quote details card input fields */\n.quoteDetailsCardBody label {\n  display: block;\n  margin-top: 1rem;\n  margin-bottom: 5px;\n  font-size: 2rem;\n}\n\n/* Style the quote details card input and textarea */\n.quoteDetailsCardBody input,\n.quoteDetailsCardBody textarea,\n.quoteDetailsCardBody select {\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 2rem;\n}\n\n/* Style the quote details actions */\n.quoteDetailsActions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n/* Style the quote details buttons */\n.quoteDetailsActions button {\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
